<template>
  <div class="date">{{ format(new Date(), dateFormat) }}</div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "CurrentDate",
  data() {
    return {
      format
    };
  },
  props: {
    dateFormat: {
      type: String,
      default: "MMMM do, yyyy"
    }
  }
};
</script>
